import React from 'react'
import { arrayOf, func, string } from 'prop-types'

import ButtonAsLink from 'views/components/molecules/ButtonAsLink'

import './SearchHistory.scss'

const SearchHistory = props => {
  const { searchHistory, handleClearHistory, handleQueryUpdate } = props

  const handleClick = event => {
    event.stopPropagation()
    event.preventDefault()

    if (handleClearHistory) {
      handleClearHistory()
    }
  }

  return (
    <div className="u-padding">
      <div className="l-flex">
        <div className="l-flex__primary">
          <strong>Zuletzt gesucht</strong>
        </div>
        <div>
          <ButtonAsLink name="searchistory-delete" onClick={handleClick}>
            <span className="u-font-weight--bold">löschen</span>
          </ButtonAsLink>
        </div>
      </div>
      <div>
        {searchHistory.length > 0 && (
          <ul className="o-SearchHistory__list a-list-reset">
            {searchHistory.map((query, index) => (
              <li
                className="u-padding--ends u-border--bottom"
                // eslint-disable-next-line react/no-array-index-key
                key={`searchistory-link-${index}`}
              >
                <ButtonAsLink
                  name={`searchistory-link-${index}`}
                  neutral
                  onClick={() => handleQueryUpdate(query)}
                  left
                  fullWidth
                >
                  {query}
                </ButtonAsLink>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  )
}

SearchHistory.propTypes = {
  searchHistory: arrayOf(string),
  handleClearHistory: func,
  handleQueryUpdate: func
}

SearchHistory.defaultProps = {
  searchHistory: [],
  handleClearHistory: null,
  handleQueryUpdate: null
}

export default SearchHistory
